import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore, CollectionReference, Query } from '@angular/fire/compat/firestore';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Observable } from 'rxjs';
import { CreateDaigakuData, Daigaku, UpdateDaigakuData } from '../models/daigaku';
import { CallableFunction, Collection } from '../resources/app-firebase';
import { map } from 'rxjs/operators';
import { DeleteDaigakuResponse } from '../models/delete-daigaku-response';
import { DeleteDaigakuRequest } from '../models/delete-daigaku-request';

@Injectable({
  providedIn: 'root'
})
export class DaigakuService {
  constructor(private afAuth: AngularFireAuth, private afs: AngularFirestore, private aff: AngularFireFunctions) {}

  findDaigaku(daigakuId: string): Observable<Daigaku> {
    return this.afs
      .collection(Collection.DAIGAKU)
      .doc<Daigaku>(daigakuId)
      .get()
      .pipe(map(snapshot => (snapshot.exists ? snapshot.data() : {}) as Daigaku));
  }

  findDaigakus(
    daigakuId: string,
    daigakuCode: string,
    daigakuName: string,
    daigakuSubName: string,
    prefectureId: string
  ): Observable<Daigaku[]> {
    return this.afs
      .collection<Daigaku>(Collection.DAIGAKU, ref => {
        let query: CollectionReference | Query = ref;
        if (daigakuId) query = query.where('daigakuId', '==', daigakuId);
        if (daigakuCode) query = query.where('daigakuCode', '==', daigakuCode);
        if (daigakuName) query = query.where('daigakuName', '==', daigakuName);
        if (daigakuSubName) query = query.where('daigakuSubName', '==', daigakuSubName);
        if (prefectureId) query = query.where('prefectureId', '==', prefectureId);
        return query;
      })
      .get()
      .pipe(
        map(snapshot =>
          snapshot.empty
            ? []
            : snapshot.docs.map(doc => {
                const data = doc.data();
                data.id = doc.id;
                return data as Daigaku;
              })
        ),
        map(daigaku => daigaku)
      );
  }

  createDaigaku(daigaku: CreateDaigakuData): Observable<Daigaku> {
    const callable = this.aff.httpsCallable<CreateDaigakuData, Daigaku>(CallableFunction.CREATE_DAIGAKU);
    return callable(daigaku);
  }

  updateDaigaku(daigaku: UpdateDaigakuData): Observable<Daigaku> {
    const callable = this.aff.httpsCallable<UpdateDaigakuData, Daigaku>(CallableFunction.UPDATE_DAIGAKU);
    return callable(daigaku);
  }

  deleteDaigaku(id: string): Observable<DeleteDaigakuResponse> {
    const req: DeleteDaigakuRequest = { id };
    const callable = this.aff.httpsCallable(CallableFunction.DELETE_DAIGAKU);
    return callable(req);
  }
}
